export enum DfaTypes {
    MonetaryRequirement = 'MonetaryRequirement',
    MonetaryRequirementCoupon = 'MonetaryRequirementCoupon',
    Encumbrance = 'Encumbrance',
}

export enum IssueProposalStatuses {
    Created = 'Created',
    Processing = 'Processing',
    Approved = 'Approved',
    Rejected = 'Rejected',
    NotIssued = 'NotIssued',
    Issued = 'Issued',
    Success = 'Success',
    Cancelled = 'Cancelled',
}
